import { Component, OnInit } from '@angular/core';
import { Router } from "@angular/router";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatDialog } from '@angular/material/dialog';
import { ControlStockConst } from '../const';
import { DummyComponent } from '../../../shared/dummy.component';
import { ControlStockService } from './controlstock.service';
import { ControlStockModel } from './controlstock.model';
import { ControlStockDialogDeleteComponent } from './controlstock-dialog-delete.component';

@Component({
    selector: 'convfact-controlstock-list',
    templateUrl: './controlstock-list.component.html',
    styleUrls: ['./controlstock.component.css'],
    standalone: false
})

export class ControlStockListComponent implements OnInit {

  constructor(
    private router: Router,
    private controlStockService: ControlStockService,
    public snackBar: MatSnackBar,
    public dialog: MatDialog,
    public dummy: DummyComponent
  ) { }

  dataSource: ControlStockModel[] = [];
  empty: boolean = false;
  ready: boolean = false;

  headerTable: any[] = ControlStockConst.headerTable;

  displayInfo(message: string): void {
    const options = new MatSnackBarConfig();
    options.duration = 10000;
    options.panelClass = ['custom-snackbar', 'custom-snackbar-container']; this.snackBar.open(message, '', options);
  }

  create(): void {
    this.router.navigate(['/concept/controlstock/create']);
  }

  edit(uid: string): void {
    this.router.navigate(['/concept/controlstock/edit' + `/${uid}`]);
  }

  delete(uid: string): void {
    this.dialog.open(ControlStockDialogDeleteComponent, {
      data: { uid: uid }
    })
      .afterClosed().subscribe(result => {
        this.dummy.redirectTo(this.router.url)
      });
  }

  ngOnInit() {
    this.controlStockService.list().then(
      data => {
        this.dataSource = data;
        if (this.dataSource.length == 0) {
          this.empty = true;
        } else {
          this.empty = false;
        }
        this.ready = true;
      });
  }


}
